import React from 'react'
import { Link } from 'gatsby'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        inProgress="true"
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <SectionTitle>Variants</SectionTitle>
        <p>
          Keep a margin of 16px between the text input and any components above
          or below it. Text inputs will fill 100% width of the parent container
          when standing alone. When inline with another component, they will
          fill 50% width. Keep a 16px margin between the text input and any
          inline components.
        </p>
        <Showcase
          site={data.site}
          title="Text Input"
          text="Use the default text field when the expected input is a single line, such as a name or phone number."
          code={code.input}
        >
          <div>
            <label for="label-1" className="c-label">
              Label Name
            </label>
            <input
              type="text"
              className="c-text-field"
              id="label-1"
              placeholder="e.g. Homer J. Simpson"
            />
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Text Area"
          text="	Use the textarea field when the expected input is more than one line, such as a comment or contact request."
          code={code.textarea}
        >
          <div>
            <label for="label-2" className="c-label">
              Label Name
            </label>
            <textarea
              name=""
              className="c-textarea"
              id="label-2"
              placeholder="Textarea placeholder"
            ></textarea>
          </div>
        </Showcase>
        <SectionTitle>States</SectionTitle>
        <p>
          In addition to the default state, both types of text inputs have
          hover, focus, change and blur states. Optional success and loading
          states are also available. The error state takes the form of an{' '}
          <Link className="link" to="/components/inline-error/design">
            Input Error
          </Link>{' '}
          component.
        </p>
        <Showcase
          site={data.site}
          title="Success Text Input"
          text="The success state is a validation state that tells the user their entry is valid."
          code={code.success}
        >
          <div>
            <label for="label-3" className="c-label">
              Label Name
            </label>
            <input
              type="text"
              className="c-text-field"
              id="label-3"
              placeholder="e.g. Homer J. Simpson"
              value="John Doe"
            />
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Disabled Text Input"
          text="The disabled state makes it impossible for the user to interact with the text input unless/until they interact with a different element on the page."
          code={code.disabled}
        >
          <div>
            <label for="label-4" className="c-label">
              Label Name
            </label>
            <input
              type="text"
              className="c-text-field--disabled"
              id="label-4"
              placeholder="e.g. Homer J. Simpson"
              value="John Doe"
              disabled
            />
          </div>
        </Showcase>
        {/* okay but do the success and disabled states actually exist? */}
        <SectionTitle>Microcopy</SectionTitle>
        <h4>Labels</h4>
        <p>
          Labels should prompt the user to enter the necessary information using
          as few words as possible. Maximum length is one line of text at 310px
          width. If the label is a full sentence, use sentence case with no end
          punctuation, unless the label is a question. Otherwise use title case
          with no end punctuation.
        </p>
        <h4>Placeholders</h4>
        <p>
          Placeholders should give the user an example or show the required
          format of the input. Never use a placeholder instead of a label, as
          the user will lose the prompt once they begin typing. Use sentence
          case with no end punctuation, unless otherwise dictated by the input
          format.
        </p>
        <h4>Captions</h4>
        <p>
          Captions provide the user with more information than can fit in the
          label, including tips and notes. Write in full sentences and stay
          focused on the overall prompt. Use sentence case with end punctuation.
        </p>
        <SectionTitle>Usage Instance</SectionTitle>
        <p>
          The text input component is used in the following patterns, which each
          have additional guidelines:
        </p>
        <ul>
          <li> Inline Help</li>
          <li> User ID (Default) </li>
          <li> User ID (Remembered) </li>
          <li>Passcode </li>
          <li> Passcode Creation </li>
          <li> PIN </li>
          <li> PIN Creation </li>
          <li> Credit/Debit Card Number </li>
          <li> Social Security Number (Full) </li>
          <li> Social Security Number (Last 4 Digits) </li>
          <li> One Time Passcode </li>
          <li> Account Number </li>
          <li> Security Question Answer</li>
          <li> Security Question Creation </li>
          <li> Currency </li>
          <li> Date (Full – MM/DD/YYYY) </li>
          <li>Date (Abbreviated – MM/YY) </li>
          <li> Phone Number </li>
          <li> Name </li>
          <li> Primary Address </li>
          <li>Routing Number</li>
        </ul>
      </Layout>
    </>
  )
}

export const code = {}
